import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactComponent as CloseIcon } from '../../assets/images/CloseIcon.svg';
import { Typography, Paper, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

const JustificationDialog = ({ open, setJustificationOpen, valueData, setPirDataValue, pirDataValue, handleContinue, showButton, setPirValue }) => {
    const navigate = useNavigate();

    const handleClose = () => {
        setJustificationOpen(false)
    };

    const handleChange = (event) => {
        setPirDataValue((prevObject) => ({
            ...prevObject,
            justification_for_net_price_change: event?.target?.value,
        }));
        setPirValue((prevObject) => ({
            ...prevObject,
            justification_for_net_price_change: event?.target?.value,
        }))
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        maxWidth: "1400px",
                        borderRadius: "10px"
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    justifyContent: "flex-end"
                }}>
                    <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
                </DialogTitle>
                <DialogContent sx={{ width: "600px" }}>
                    <DialogContentText id="alert-dialog-description">
                        <Typography sx={{
                            fontFamily: "Verdana", fontSize: "14px", fontWeight: "400", color: "#000"
                        }}>
                            You have entered a price less than the recommended stock price threshold!.
                            Can this be Vendor Managed Inventory(VMI)?
                            If you absolutely need to stock and manage this part. Please enter the reason why below.
                        </Typography>
                        <div style={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            {/* <input
                                value={valueData}
                                type="text"
                                autoComplete="off"
                                name="enterJustification"
                                onChange={handleChange}
                                className="partInputField"
                            /> */}
                            <textarea
                                id="yourTextarea"
                                name="yourTextarea"
                                placeholder="Enter Comments"
                                value={valueData}
                                style={{
                                    width: "75%",
                                    fontFamily: "Verdana", // Set the font family to Verdana
                                    minHeight: "50px"
                                }}
                                onChange={handleChange}
                                className="partTextField"
                                rows={4}
                                cols={50}
                            />
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ margin: "auto" }}>
                    <button
                        type="submit"
                        className="submitButton"
                        style={{
                            fontSize: 16,
                            cursor: pirDataValue?.justification_for_net_price_change ? "default" : "pointer",
                            position: "relative",
                            fontFamily: "Verdana",
                            background: !pirDataValue?.justification_for_net_price_change ? "#f5f5f5" : "#C6003D",
                            color: !pirDataValue?.justification_for_net_price_change ? "#C6003D" : "#FFFFFF",
                        }}
                        disabled={!pirDataValue?.justification_for_net_price_change}
                        onClick={(e) => {
                            e.preventDefault();
                            handleContinue()
                            setJustificationOpen(false)
                        }}
                    >
                        Next
                    </button>
                    {showButton && (
                        <button
                            type="submit"
                            className="cancelButton"
                            style={{
                                fontSize: 16,
                                cursor: "pointer",
                                position: "relative",
                                fontFamily: "Verdana",
                                background: "#C6003D",
                                color: "#FFFFFF",
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate("/dashboard");
                            }}
                        >
                            Cancel Part Request
                        </button>
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
}

export default JustificationDialog;